import config from '../config/config';
import { AdvisorChatEvent } from '../constants/enums';

export const listChatSessions = async (api, ledgerId) => {
    const res = await api.get(`/ledger/ledgers/${ledgerId}/advisor/chat/sessions`);
    return res.data;
};

export const getChatSessionDetail = async (api, ledgerId, sessionId) => {
    const res = await api.get(`/ledger/ledgers/${ledgerId}/advisor/chat/sessions/${sessionId}`);
    return res.data;
};

export const deleteChatSession = async (api, ledgerId, sessionId) => {
    const res = await api.delete(`/ledger/ledgers/${ledgerId}/advisor/chat/sessions/${sessionId}`);
    return res.data;
};

export const streamAdvisorChat = async ({
    ledgerId,
    token,
    prompt,
    sessionId = null,
    onSession,
    onStatus,
    onDelta,
    onDone,
    onError,
    signal,
}) => {
    const url = `${config.API_URL}/ledger/ledgers/${ledgerId}/advisor/chat/ask`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
                Accept: 'text/event-stream',
            },
            body: JSON.stringify({
                prompt,
                session_id: sessionId,
            }),
            signal,
        });

        if (!response.ok) {
            let errorDetail = 'Failed to connect to AI Advisor';
            try {
                const errJson = await response.json();
                errorDetail = errJson.detail || errorDetail;
            } catch (e) {
                // Ignore parse errors
            }
            if (onError) onError(errorDetail);
            return;
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';

        while (true) {
            const { done, value } = await reader.read();
            if (done) break;

            buffer += decoder.decode(value, { stream: true });
            const parts = buffer.split('\n\n');
            buffer = parts.pop() || ''; // Keep the incomplete tail in buffer

            for (const part of parts) {
                const lines = part.split('\n');
                let currentEvent = 'message';
                let currentData = '';

                for (const line of lines) {
                    if (line.startsWith('event:')) {
                        currentEvent = line.replace('event:', '').trim();
                    } else if (line.startsWith('data:')) {
                        currentData = line.replace('data:', '').trim();
                    }
                }

                if (!currentData) continue;

                let parsedData = {};
                try {
                    parsedData = JSON.parse(currentData);
                } catch (err) {
                    console.error('Failed to parse SSE data JSON:', currentData);
                    continue;
                }

                if (currentEvent === AdvisorChatEvent.SESSION && onSession) {
                    onSession(parsedData);
                } else if (currentEvent === AdvisorChatEvent.STATUS && onStatus) {
                    onStatus(parsedData);
                } else if (currentEvent === AdvisorChatEvent.DELTA && onDelta) {
                    onDelta(parsedData.text || '');
                } else if (currentEvent === AdvisorChatEvent.DONE && onDone) {
                    onDone(parsedData);
                } else if (currentEvent === AdvisorChatEvent.ERROR && onError) {
                    onError(parsedData.error || 'Stream error');
                }
            }
        }
    } catch (err) {
        if (err.name === 'AbortError') {
            console.log('Advisor stream generation aborted by user.');
        } else {
            console.error('Error during SSE chat stream:', err);
            if (onError) onError(err.message || 'Stream connection failed');
        }
    }
};
